<template>
    <div>
        <PagesContent lang="en" tab="13" sub="1303"></PagesContent>
    </div>
</template>

<script setup lang="ts">
import langObj from "@/utils/lang";
var lng: any = langObj['en']
useSeoMeta({
    title: lng['力士达集团'],
    description: '力士达集团',
    keywords: '力士达, lsd',
});
</script>